import React from "react";
import { Alert } from "@mui/material";

export default function CustomizedAlert(props) {
  return (
    <div
      className="alert-content"
      style={{ display: "flex", justifyContent: "center" }}
    >
      <Alert
        severity={props.alertType ? props.alertType : "info"}
        sx={{ boxShadow: "3px 3px 7px rgb(0, 0, 0, 0.2)", color: "#2f3542" }}
      >
        {props.alertMessage}
      </Alert>
    </div>
  );
}
